import RavelloService from '@/services/ravello'

export const MyNotifications = {
	name: 'My Notifications',
	route: 'my-notifications',
}

export const MyNotification = {
	name: 'Notification',
	route: 'my-notification',
	params: ['notification'],
	lazyName: {
		fn: async notification => RavelloService.get(`/v1/me/notifications/${notification}`),
		params: ['notification'],
		field: 'title',
	},
}
